// extracted by mini-css-extract-plugin
export var actionButton = "_qt-0";
export var actionMenuContainer = "_qt-i";
export var bubble = "_qt-2";
export var bubbleActionMenu = "_qt-j";
export var bubbleContext = "_qt-6";
export var bubbleItems = "_qt-7";
export var customer = "_qt-3";
export var divider = "_qt-8";
export var fileList = "_qt-9";
export var hiddenComment = "_qt-o";
export var infoAbove = "_qt-a";
export var internal = "_qt-4";
export var lightActionButton = "_qt-1";
export var link = "_qt-b";
export var merchant = "_qt-5";
export var message = "_qt-c";
export var profilePicture = "_qt-e";
export var quillToolbarContainer = "_qt-f";
export var senderDate = "_qt-g";
export var senderDateCustomer = "_qt-h";
export var senderName = "_qt-d";
export var time = "_qt-k";
export var uploadedImage = "_qt-l";
export var username = "_qt-m";
export var xsmall = "_qt-n";